import GridInterface from '../../Interfaces/GridInterface';
import BoxType from './Interfaces/BoxTypeWithState';

const grid: GridInterface[] = [
    { name: 'Id', label: 'Id', align: 'center', field: (row: BoxType) => row.id, sortable: true, visible: true, searchable: true, disable: true },
    { name: 'Name', label: 'Nome', align: 'center', field: (row: BoxType) => row.boxName, sortable: true, visible: true, searchable: true, disable: true },
    { name: 'Mac Address', label: 'Mac Address', align: 'center', field: (row: BoxType) => row.macAddress, sortable: true, visible: true, searchable: true, disable: true },
    { name: 'Tenant', label: 'Tenant', align: 'center', field: (row: BoxType) => row.tenantId, sortable: true, visible: true, searchable: true, disable: true },
    { name: 'Stato', label: 'Stato', align: 'center', field: (row: BoxType) => row.online, sortable: true, visible: true, searchable: true, disable: true }
]

export default grid;